export default __webpack_public_path__ + "static/download-image-1-68fcfc0885892fabb6b29326ee0a7da0.png";